<template>
  <div class="footer">
    <div class="container is-boxed-fluid">
      <div class="row">
        <div class="col-3">
          <img src="/img/logo.svg" class="logo" alt />
          <div class="supported-cards">
            <ul>
              <li>
                <img src="/img/arca.svg" alt />
              </li>
              <li>
                <img src="/img/visa.svg" alt />
              </li>
              <li>
                <img src="/img/mastercard.svg" alt />
              </li>
              <li>
                <img src="/img/idram.png" alt />
              </li>
            </ul>
          </div>
        </div>
        <div
          class="footer-links"
          :class="col.col"
          v-for="(col, col_key) in $t('footer')"
          :key="col_key"
        >
          <h3>{{col.title}}</h3>
          <ul>
            <li v-for="(link, key) in col.items" :key="key">
              <router-link :to="$i18nRoute({name: link.name, params: link.params})" v-if="link.name" v-html="link.text"></router-link>
              <a :href="link.href" v-else v-html="link.text"></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="container is-boxed-fluid copyright">
      <div class="row ns">
        <div class="col-6 col-xs-12">{{$t('copyright')}}</div>
        <div class="col-6 col-xs-12">
          <socials></socials>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Socials from '@/components/global/Social.vue';
export default {
  components: {
    Socials
  },
  data () {
    return {
      links: [
        {
          title: 'Էջեր',
          col: 'col-3 col-md-12',
          items: [
            {
              text: 'Մեր մասին',
              name: '/about-us'
            },
            {
              text: 'Զեղչ',
              name: '/shop'
            },
            {
              text: 'Նոր',
              name: '/shop'
            },
            {
              text: 'Առցանց խանութ',
              name: '/shop'
            },
            {
              text: 'Արծաթյա զարդեր',
              name: '/shop'
            },
            {
              text: 'Lookbook',
              name: '/shop'
            },
            {
              text: 'Բլոգ',
              name: '/editorials'
            },
            {
              text: 'Հետադարձ կապ',
              name: '/contacts'
            }
          ]
        },
        {
          title: 'Սպասարկում',
          col: 'col-3 col-md-12',
          items: [
            {
              text: 'Առաքում և վճարում',
              name: '/pages/return-terms',
              params: { page: 'return-terms' }
            },
            {
              text: 'Հաճախ տրվող հարցեր',
              name: 'faq'
            },
            {
              text: 'Անվտանգություն',
              name: '/pages/privacy-policy',
              params: { page: 'privacy-policy' }
            },
            {
              text: 'Դրույթներ և պայմաններ',
              name: '/pages/terms-and-conditions',
              params: { page: 'terms-and-conditions' }
            },
            {
              text: 'Վերադարձ և Փոխանակում',
              name: '/pages/return-terms',
              params: { page: 'return-terms' }
            }
          ]
        },
        {
          title: 'Կոնտակտներ',
          col: 'col-3 col-md-12',
          items: [
            {
              text:
                'Ներկայացված է հետևյալ խանութներում:<br>5 Concept Store - Սայաթ Նովա 5, Երևան'
            },
            {
              text: '+ 374 55 55 55 55',
              href: 'tel:+ 374 55 55 55 55'
            },
            {
              text: 'customercare@petoor.com',
              href: 'mailto:customercare@petoor.com'
            }
          ]
        }
      ]
    }
  }
}
</script>

<style lang="scss">
.footer {
  background-color: #F6F6F6;
  padding-top: 40px;
  padding-bottom: 20px;

  .logo {
    width: 150px;
    @include mq($ms) {
      width: 90px;
    }
  }
  .supported-cards {
    margin-top: 60px;

    @include mq($ms) {
      margin-top: 30px;
    }

    ul {
      display: flex;
      li {
        margin-right: 20px;
        img{
          height: 35px;
          border-radius: 4px;
        }
      }
    }
  }

  .footer-links {
    h3 {
      font-family: $font-bold;
    }
    ul {
      li {
        a {
          line-height: 30px;
        }
      }
    }
  }

  .copyright {
    font-size: 16px;
    margin-top: 15px;
  }

  .social-links {
    margin: 0;

    @include mq(false, $ms) {
      float: right;
    }

    @include mq($ms) {
      margin-top: 30px;
    }

    li {
      &:not(:last-child){
        margin-right: 20px;
      }
      a {
        color: $main-color;
      }
    }
  }
}
</style>
